import { createRouter, createWebHistory } from 'vue-router';

const routes = [
    {
        path: '/login',
        name: 'Login',
        component: () => import('@pages/Login.vue')
    },
    {
        path: '',
        component: () => import('@pages/Dashboard.vue'),
        redirect: { name: 'Products' },
        children: [
            {
                path: '/terminy-limity-objednavok',
                name: 'OrderLimits',
                meta: { title: 'Termíny a limity objednávok' },
                component: () => import('@components/ordersLimits/OrderLimits.vue')
            },
            {
                path: '/produkty',
                name: 'Products',
                meta: { title: 'Produkty' },
                component: () => import('@components/product/Products.vue')
            },
            // {
            //     path: '/produkt/:id',
            //     name: 'ProductDetail',
            //     meta: { title: 'Produkt' },
            //     component: () => import('@pages/dashboard/Product.vue'),
            // },
            {
                path: '/bannery',
                name: 'Banners',
                meta: { title: 'Bannery' },
                component: () => import('@components/banner/Banners.vue')
            },
            {
                path: '/newslettre',
                name: 'Newsletters',
                meta: { title: 'Newslettre' },
                component: () => import('@components/newsletters/Newsletters.vue')
            },
            {
                path: '/popupy',
                name: 'Popups',
                meta: { title: 'Popupy' },
                component: () => import('@components/popup/Popups.vue')
            },
            {
                path: '/kategorie',
                name: 'Categories',
                meta: { title: 'Kategórie' },
                component: () => import('@components/category/Categories.vue')
            },
            {
                path: '/zakaznici',
                name: 'Customers',
                meta: { title: 'Zákazníci' },
                component: () => import('@components/customer/Customers.vue')
            },
            {
                path: '/sviatky',
                name: 'Holidays',
                meta: { title: 'Sviatky' },
                component: () => import('@components/holidays/Holidays.vue')
            },
            {
                path: '/velkoobchodne-akcie',
                name: 'Promotions',
                meta: { title: 'VO' },
                component: () => import('@components/promotions/Promotions.vue')
            },
            {
                path: '/manazovanie-cien',
                name: 'PriceManagement',
                meta: { title: 'Manažovanie cien' },
                component: () => import('@components/priceManagement/PriceManagement.vue')
            },
            {
                path: '/mnozstevne-zlavy',
                name: 'QuantityDiscounts',
                meta: { title: 'Množstevné zľavy' },
                component: () => import('@components/discounts/QuantityDiscounts.vue')
            },
            {
                path: '/nulove-zasoby',
                name: 'ZeroStock',
                meta: { title: 'Nulové zásoby' },
                component: () => import('@components/zeroStocks/ZeroStocks.vue')
            },
            {
                path: '/monitoring',
                name: 'Monitoring',
                meta: { title: 'Monitoring' },
                component: () => import('@components/monitoring/Monitoring.vue')
            },
        ]
    },
    {
        path: '/:catchAll(.*)',
        name: 'NotFound',
        component: () => import('@pages/404.vue')
    }
];


const router = createRouter({
    history: createWebHistory(),
    routes
});

router.beforeEach((to, from, next) => {
    const isLoggedIn = !!localStorage.getItem('access-token');

    if (to.name !== 'Login' && !isLoggedIn) {
        next({ name: 'Login', query: { redirect: to.fullPath } });
    } else {
        next();
    }
});

export default router;
